.contentBox {
  padding: 16px;
  margin: 8px;
  border-width: 2px;
  border-style: solid;
  border-radius: 8px;
  border-color: var(--tuna-palette-action-hover);
  background-color: var(--tuna-palette-action-hover);
  flex: 1 1 auto;
  min-width: 0;
}

.iconBox {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  padding: 8px;
}

.messageRow {
  width: 90%;
  align-items: center;
}

.messageRow--highlight {
  border-color: var(--tuna-palette-success-light);
  border-style: dashed;
  border-width: 2px;
}

.name {
  margin-top: 16px;
  font-size: 12px;
  color: var(--tuna-palette-text-secondary);
}

.timestampLeft {
  margin-left: 48px;
}

.timestampRight {
  margin-right: 48px;
}
